// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__1Bj1s","input":"Input_input__1wuvu","label":"Input_label__qTbIS","error":"Input_error__SHdbV"};